<template>
  <div class="base-virtual-list" v-bind="$attrs">
    <template
      v-for="(item, index) in dataSources"
      :key="item && dataKey in item ? item[dataKey] : index">
      <slot :item="item" :index="index" />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'VirtualList',
  inheritAttrs: false,
  props: {
    dataSources: {
      type: Array,
      default: () => [],
    },
    dataKey: {
      type: String,
      default: 'id',
    },
  },
  methods: {
    getOffset() {
      return this.$el ? this.$el.scrollTop : 0
    },
    getScrollSize() {
      return this.$el ? this.$el.scrollHeight : 0
    },
    getClientSize() {
      return this.$el ? this.$el.clientHeight : 0
    },
    scrollToOffset(offset) {
      if (this.$el) {
        this.$el.scrollTop = offset
      }
    },
  },
})
</script>